import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale('en');

const handleWheel = (event: { ctrlKey: any; deltaY: number; preventDefault: () => void; }) => {
  // 检查是否按下了Ctrl键
  if (event.ctrlKey && event.deltaY !== 0) {
    event.preventDefault(); // 阻止默认的滚轮行为
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_router_view)
  ]))
}
}

})